import { render, staticRenderFns } from "./LotesPendentes.vue?vue&type=template&id=4ae61e94"
import script from "./LotesPendentes.vue?vue&type=script&lang=js"
export * from "./LotesPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports